import { Stack } from "@mantine/core";
import { IIssueApi } from "@schemas/issueSchema";
import GlobalFileUploaderTable from "../../../../../../components/FileUploader/GlobalFileUploaderTable";

type IssueItemModalFilesProps = {
  issue: IIssueApi;
  projectId: string;
};

const IssueItemModalFiles = ({ issue, projectId }: IssueItemModalFilesProps) => {
  return (
    <Stack gap="md" w="100%">
      <GlobalFileUploaderTable path={`${projectId}/issue/${issue?._id}/files`} />
    </Stack>
  );
};

export default IssueItemModalFiles;
